export enum TimeZone {
  Lisbon = 'Europe/Lisbon',
}
